import { HttpMethod, IFramework, IWebServiceManager } from "@truckdown/framework";
import { ApiResultModel } from "../ApiResultModel";
import { IUserCreator } from "./IUserCreator";
import { RegisterUserModel } from "./RegisterUserModel";

class UserCreator implements IUserCreator {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    register(model: RegisterUserModel): Promise<ApiResultModel> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/user/register',
            method: HttpMethod.POST
        }, model);

        return new Promise<ApiResultModel>((resolve, reject) => {
            this.manager
                .get<ApiResultModel>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve({ ok: false, message: 'There was an error registering a new account' });
                })
        });
    }

}

export default (framework: IFramework) => {
    framework.registerTransient<IUserCreator>('IUserCreator', (frm) => {
        return new UserCreator(frm);
    });
}
